import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';
import { assistencia24hApiNew } from '@/api/Assistencia24hApi';
import { RelatorioOrcamentoFrotaModel } from "@/models/contabil/orcamento-frota/RelatorioOrcamentoFrotaModel"
import PageDTO from "@/api/commons/PageDTO";
import FiltroConsultaFrotaDTO from "@/api/integracao-contabil/FiltroConsultaFrotaDTO"
import FiltroLeadFrotaDTO from "@/api/integracao-contabil/FiltroLeadFrotaDTO"

export default class ContabilOrcamentoFrotaService { 

    static gerarRelatorio(relatorio : RelatorioOrcamentoFrotaModel): Promise<any> {
        const requestRelatorioOrcamentoFrotaDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
            idCliente: relatorio.cliente?.id,
            status: relatorio.status,
        }

        return integracaoContabilApi.gerarRelatorioOrcamentoFrota(requestRelatorioOrcamentoFrotaDTO);
    }

    static gerarRelatorioExcel(relatorio : RelatorioOrcamentoFrotaModel): Promise<any> {

        const requestRelatorioOrcamentoFrotaDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
            idCliente: relatorio.cliente?.id,
            status: relatorio.status,
        }

        return integracaoContabilApi.gerarRelatorioOrcamentoFrotaExcel(requestRelatorioOrcamentoFrotaDTO);
    }

    static consultarRelatorioOrcamentoFrota(relatorio : RelatorioOrcamentoFrotaModel): Promise<any> {

        const requestRelatorioOrcamentoFrotaDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
            idCliente: relatorio.cliente?.id,
            status: relatorio.status,
        }

        return integracaoContabilApi.consultarRelatorioOrcamentoFrota(requestRelatorioOrcamentoFrotaDTO);
    }

    static consultar(filtro: any) {

        let filtroApi = new FiltroConsultaFrotaDTO(           
            filtro.dataDe,
            filtro.dataAte,
            filtro.fatura,
            filtro.tipoServico,
            filtro.idCliente,
        );

        return assistencia24hApiNew.consultarServicosFrota(filtroApi);
    }

    static consultarLeadFrota(filtro: any) {

        let filtroApi = new FiltroLeadFrotaDTO(           
            filtro.dataInicio,
            filtro.dataFim
        );

        return assistencia24hApiNew.consultarLeadFrota(filtroApi);
    }

    static consultarLeadFrotaId(id: any) {
        return assistencia24hApiNew.consultarLeadFrotaId(id);
    }

    static gerarRelatorioLeadsFrota(tipo: string, request: FiltroLeadFrotaDTO) {
        return assistencia24hApiNew.gerarRelatorioLeadsFrota(tipo, request);
    }

    static gerarFatura(faturas: any) {
        return assistencia24hApiNew.gerarFaturaServicosFrota(faturas);
    }

    static imprimirFatura(idCliente: number, numeroFatura: string) {

        let imprimirFatura = {
            idCliente: idCliente,
            numeroFatura: numeroFatura
        };

        return assistencia24hApiNew.imprimirFatura(imprimirFatura);
    }

    static validarPagamentoFatura(filtro: any) {
        return assistencia24hApiNew.validarPagamentoFaturaServicosFrota(filtro);
    }

    static relatorioFaturamento(filtro: any, tipo: any) {

        let filtroApi = new FiltroConsultaFrotaDTO(           
            filtro.dataDe,
            filtro.dataAte,
            filtro.fatura,
            filtro.tipoServico,
            filtro.idCliente,
        );

        if (tipo == 'PDF') {
            return assistencia24hApiNew.gerarRelatorioServicosFrotaPDF(filtroApi);
        }

        return assistencia24hApiNew.gerarRelatorioServicosFrotaXLS(filtroApi);
    }

}

